// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._FzltBY9qbFMvdh24Fjg {
  text-align: center;
}

.Q0L5LoiBk6I6oPANq0xG {
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/components/EmailVerify/components/TokenExpired/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".contentDescription {\n  text-align: center;\n}\n\n.contentTitle {\n  font-weight: 900;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentDescription": `_FzltBY9qbFMvdh24Fjg`,
	"contentTitle": `Q0L5LoiBk6I6oPANq0xG`
};
export default ___CSS_LOADER_EXPORT___;
